module.exports = __webpack_public_path__ + "img/nr.6f7fcd21.svg";